// extracted by mini-css-extract-plugin
export var component = "Services-module--component--tO3tq";
export var list = "Services-module--list--5mtHe";
export var link = "Services-module--link--srDHr";
export var current = "Services-module--current--FTxzQ";
export var label = "Services-module--label--q3kfP";
export var roundIcon = "Services-module--roundIcon--j27-l";
export var linkIcon = "Services-module--linkIcon--N88ss";